/** MIME types sent to Gemini as inline binary (Vertex-supported). */
export const GEMINI_INLINE_MIME_TYPES = new Set(['application/pdf', 'text/plain']);

/** Office formats analyzed after local text extraction (zip-based OOXML / ODF only). */
export const GEMINI_OFFICE_TEXT_MIME_TYPES = new Set([
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]);

/**
 * Checks whether the MIME type can be sent to Gemini as inline binary.
 * @param mimeType MIME type from upload metadata, if known.
 * @returns True when the MIME type is supported for inline upload.
 */
export function isGeminiInlineMimeType(mimeType?: string): boolean {
  if (!mimeType) {
    return false;
  }

  return GEMINI_INLINE_MIME_TYPES.has(mimeType.toLowerCase());
}

/**
 * Checks whether the MIME type is an Office format analyzed after local text extraction.
 * @param mimeType MIME type from upload metadata, if known.
 * @returns True when text can be extracted locally before sending to Gemini.
 */
export function isGeminiOfficeTextMimeType(mimeType?: string): boolean {
  if (!mimeType) {
    return false;
  }

  return GEMINI_OFFICE_TEXT_MIME_TYPES.has(mimeType.toLowerCase());
}

/**
 * Checks whether M.ia can analyze this MIME type (inline PDF or extracted Office text).
 * @param mimeType MIME type from upload metadata, if known.
 * @returns True when the file can be included in an assignment AI review.
 */
export function isGeminiReadableMimeType(mimeType?: string): boolean {
  return isGeminiInlineMimeType(mimeType) || isGeminiOfficeTextMimeType(mimeType);
}
